import React from "react";
import Anacondass01 from "../../../../assets/images/Anaconda-ss-01.png";
import Anacondass02 from "../../../../assets/images/Anaconda-ss-02.png";
import Anacondass03 from "../../../../assets/images/Anaconda-ss-03.png";

import Anacondass04 from "../../../../assets/images/Anaconda-ss-04.png";
import Anacondass05 from "../../../../assets/images/Anaconda-ss-05.png";
import Anacondass06 from "../../../../assets/images/Anaconda-ss-06.png";

import Anacondass07 from "../../../../assets/images/Anaconda-ss-07.png";
import Anacondass08 from "../../../../assets/images/Anaconda-ss-08.png";
import Anacondass09 from "../../../../assets/images/Anaconda-ss-09.png";

import Anacondass10 from "../../../../assets/images/Anaconda-ss-10.png";
import Anacondass11 from "../../../../assets/images/Anaconda-ss-11.png";
import Anacondass12 from "../../../../assets/images/Anaconda-ss-12.png";

import Anacondass13 from "../../../../assets/images/Anaconda-ss-13.png";
import Anacondass14 from "../../../../assets/images/Anaconda-ss-14.png";

const PythonIdeguide = () => {
  return (
    <div>
      <div className="container mx-auto p-5">
        <h1 className="text-3xl font-bold text-center mb-8">
          Software Installation Steps
        </h1>
        <div>
          <p className="text-justify">
            Data science, machine learning, and scientific computing all make
            extensive use of Anaconda, a well-known open-source installation of
            Python and R. It includes tools like Jupyter, Sypder, and others
            that can handle a lot of data sets and processes based on user
            requirements. It facilitates the simplification of package
            deployment and management, which fosters a stable environment for a
            range of data-related tasks. This guide will lead you through the
            process of instructions forn installing Anaconda software.
          </p>
        </div>
        <div className="step mb-8">
          <h2 className="text-2xl font-semibold mt-5">
            Step 1: Visit the Anaconda official website to download software
          </h2>
          <p className="mt-5">
            Go to the official website :
            <a href="https://www.anaconda.com/">https://www.anaconda.com/</a>{" "}
            and click on <strong>"Free Download"</strong> option.
          </p>
          <img
            src={Anacondass01}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Anaconda Download Screenshot one"
          />
          <p className="mt-5">
            Skip the Registration (optional) and proceed to next page:
          </p>
          <img
            src={Anacondass02}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Skip registration Screenshot"
          />

          <p className="mt-5">
            Based on your operating system download appropriate installer:
          </p>
          <img
            src={Anacondass03}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Installer Download Screenshot"
          />
        </div>
        <div className="step mb-8">
          <h2 className="text-2xl font-semibold mt-5">
            Step 2: Run the Installer
          </h2>
          <p className="mt-3">
            Navigate to the downloaded file location and make a double-click on
            it to start the installation process.
          </p>
          <img
            src={Anacondass04}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Start installation Screenshot"
          />
        </div>
        <div className="step mb-8">
          <h2 className="text-2xl font-semibold mt-5">
            Step 3: Follow the Setup Wizard
          </h2>
          <p className="mt-3">
            Follow the on-screen instructions to complete the installation.
          </p>
          <img
            src={Anacondass05}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Setup Wizard Screenshot"
          />

          <p className="mt-5">
            Choose <strong>Just Me</strong> if you want only one person to use
            the program; otherwise, choose <strong>All Users</strong> (for all
            system users).
          </p>
          <img
            src={Anacondass06}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Setup Wizard Screenshot two"
          />

          <p className="mt-5">
            Browse the location where you wish to install the software and click
            <strong>"Next”</strong> to proceed ahead.
          </p>
          <img
            src={Anacondass07}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Setup Wizard Screenshot three"
          />

          <p className="mt-5">
            Select if you want to include Anaconda in the PATH environment
            variable for your system. Additionally, note that adding Anaconda to
            the PATH may cause issues for other programs and affect the choice
            of whether to choose Anaconda as the default Python.
            <br /> You can keep the default options and proceed to{" "}
            <strong>"Install"</strong>:
          </p>
          <img
            src={Anacondass08}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Setup Wizard path Screenshot"
          />

          <p className="mt-5">Wait for installation to complete:</p>
          <img
            src={Anacondass09}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Setup Wizard in progress Screenshot"
          />
        </div>
        <div className="step mb-8 mt-5">
          <h2 className="text-2xl font-semibold">
            Step 4: Finish Installation
          </h2>
          <p className="mt-2">
            Once the installation is complete, click on <strong>"Next"</strong>:
          </p>
          <img
            src={Anacondass10}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Finish Installation Screenshot one"
          />

          <p className="mt-5">
            Software is successfully installed. Now click on{" "}
            <strong>"Finish"</strong>:
          </p>
          <img
            src={Anacondass12}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Finish Installation Screenshot"
          />
        </div>

        <div className="step mb-8 mt-5">
          <h2 className="text-2xl font-semibold">
            Step 5: Verify the Installation
          </h2>
          <p className="mt-2">
            Search for <strong>"Anaconda Navigator"</strong> in Start menu and
            open it:
          </p>
          <img
            src={Anacondass13}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Verify Installation Screenshot"
          />

          <p className="mt-5">
            It will show screen as below. This confirms that the Anaconda
            software has been installed successfully.
          </p>
          <img
            src={Anacondass14}
            className="mt-4 rounded-lg border border-gray-300"
            alt="Finish Installation Screenshot"
          />

          <div className="mt-5">
            <hr />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PythonIdeguide;
